import React from 'react';
import { PuzzleConfig } from '../types';

type CustomPuzzleLegendProps = {
  puzzles: PuzzleConfig[];
  onHover: (dataKey: string) => void;
  onLeave: () => void;
};

export const CustomPuzzleLegend = ({ puzzles, onHover, onLeave }: CustomPuzzleLegendProps) => {
  return (
    <ul style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', listStyle: 'none', padding: '10px 0', margin: 0, position: 'relative', zIndex: 20 }}>
      {puzzles.map((puzzle, index) => (
        <li
          key={`item-${index}`}
          style={{ marginRight: 20, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          onMouseEnter={() => onHover(puzzle.dataKey)}
          onMouseLeave={onLeave}
        >
          <svg width="14" height="14" style={{ marginRight: 5 }}>
            <rect width="14" height="14" fill={puzzle.color} />
          </svg>
          <span style={{ fontSize: 14 }}>{puzzle.name}</span>
        </li>
      ))}
    </ul>
  );
};
